import React from 'react'

import {
  SecretWindowWrapper,
  SecretWindowBackground,
  SecretWindowBackgroundRegular,
  SecretWindowBackgroundEmphasis,
  SecretWindowFlap,
  SecretWindowTitle,
  SecretWindowInstructions,
} from '../../styles'

const SecretWindow = ({target, open, onTouchStart, onTouchEnd}) => (
  <SecretWindowWrapper
    onMouseDown={onTouchStart}
    onTouchStart={onTouchStart}
    onMouseUp={onTouchEnd}
    onTouchEnd={onTouchEnd}
  >
    <SecretWindowBackground>
      <SecretWindowBackgroundRegular>Get</SecretWindowBackgroundRegular>
      <SecretWindowBackgroundEmphasis>{target.name}</SecretWindowBackgroundEmphasis>
      <SecretWindowBackgroundRegular>to say the word</SecretWindowBackgroundRegular>
      <SecretWindowBackgroundEmphasis>"{target.poisonWord}"</SecretWindowBackgroundEmphasis>
    </SecretWindowBackground>
    <SecretWindowFlap open={open}>
      <SecretWindowTitle>Secret Word</SecretWindowTitle>
      <SecretWindowInstructions>Tap & hold to reveal</SecretWindowInstructions>
    </SecretWindowFlap>
  </SecretWindowWrapper>
)

export default SecretWindow



// WEBPACK FOOTER //
// ./src/views/game/components/SecretWindow.jsx